module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/167.2d066296.png";